import React from "react";
import { BatteryWarning, CheckCircle2, Tag } from "lucide-react";
import { Card } from "@/components/ui/card";
import { RadioCard, SectionLabel } from "./FormPrimitives";

export const DgBrandCards = ({ form, setField }) => (
  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
    <Card className="border-zinc-200 shadow-sm">
      <div className="p-6">
        <SectionLabel hint={form.code_mode === "manual" ? "Optional" : "Step 3 / 5"}>DG / Battery</SectionLabel>
        <p className="text-sm text-zinc-700 mb-3">Battery or any DG items?</p>
        <div className="grid grid-cols-2 gap-3">
          <RadioCard testid="radio-dg-yes" checked={form.has_dg_battery === true} onClick={() => setField("has_dg_battery", true)} icon={BatteryWarning} label="Yes" sublabel="Adds T" />
          <RadioCard testid="radio-dg-no" checked={form.has_dg_battery === false} onClick={() => setField("has_dg_battery", false)} icon={CheckCircle2} label="No" sublabel="Skip" />
        </div>
      </div>
    </Card>
    <Card className="border-zinc-200 shadow-sm">
      <div className="p-6">
        <SectionLabel hint={form.code_mode === "manual" ? "Optional" : "Step 4 / 5"}>Brand on Package</SectionLabel>
        <p className="text-sm text-zinc-700 mb-3">Brand name on package?</p>
        <div className="grid grid-cols-2 gap-3">
          <RadioCard testid="radio-brand-yes" checked={form.has_brand === true} onClick={() => setField("has_brand", true)} icon={Tag} label="Yes" sublabel="Adds B" />
          <RadioCard testid="radio-brand-no" checked={form.has_brand === false} onClick={() => setField("has_brand", false)} icon={CheckCircle2} label="No" sublabel="Skip" />
        </div>
      </div>
    </Card>
  </div>
);
